	import { useState, useEffect, useContext } from 'react';
	import { useNavigate } from 'react-router-dom';
	import { useDispatch } from "react-redux";
	import AAOEModal  from "react-modal";

	import {  getLabConfig } from '../../utils/api';
	import { cartActions } from '../../store/cart';
	import MenuContext from '../../store/MenuContext';
	import CartClasses from './Cart.module.css';

	import { getAAOE, getAAOEAnswers } from '../../utils/api';
	import AAOE from '../../pages/AAOEfrm';

	const CartItem = (props) => {
		const [aaoeData, setAaoeData] = useState([]);
		const [aaoeAns, setAaoeAns] = useState([]);
		const itemid = props.item.id
		useEffect(() => {
			async function fetchAAOEData() {
        	const aaoeData = await getAAOE(itemid);
            setAaoeData(aaoeData);            
        }
        fetchAAOEData();
		}, [itemid]);
		
		useEffect(() => {
			async function fetchAAOEAnswers() {
				const AAOEAnswers = props.item.AAOEAnswers;
				const aaoeAnswers = await getAAOEAnswers(AAOEAnswers,aaoeData);
				setAaoeAns(aaoeAnswers);
			}
			fetchAAOEAnswers();
		},[aaoeData,props.item.AAOEAnswers]);
		
		const [conTests,setConTests] = useState([]);
		useEffect(() => {
			async function fetchRequiredTests() {
				const conTests2 = await getLabConfig("DTCCONDITIONALTEST");
				const parts = Array.isArray(conTests2)
				  ? conTests2.map(String).map(s => s.trim()).filter(Boolean)
				  : typeof conTests2 === "string"
				  ? conTests2.split(",").map(s => s.trim()).filter(Boolean)
				  : [];
									setConTests(parts);    
				}   
			fetchRequiredTests();
		}, []);
		const { id, name, DTCPrice, RequiredTest } = props.item;

		const navigate = useNavigate();
	    const [rules, setRules] = useState(false);	
		const dispatch = useDispatch();
		const removeFromCartHandler = () => {
			if(conTests.includes(id)) sessionStorage.setItem("Q3","No");
			dispatch(cartActions.remove(id));
		};
		const viewTestHandler = () => {
	        navigate(`../details/${props.item.id}/1/${props.item.name}`);
	    };
		const [showAAOEModal, setShowAAOEModal] = useState(false);
		function closeAAOEModal () {
			setShowAAOEModal(false);
		}
		const viewAAOEHandler = () =>{
			setShowAAOEModal(!rules);
	    };
		const handleAAOEData = (data) => {
			let data2= data['AaoeID'];
			let data3=data2.replaceAll(',','^');
			data['AaoeID']=data3;
			const aaoedata=Object.assign({aaoeanswers: data}, props.item);
			dispatch(cartActions.addAAOE(aaoedata));
			setShowAAOEModal(false);
		};

		const menuTheme = useContext(MenuContext);		

	  return (
		<div className={CartClasses.htmlText}>
		   	<span className={CartClasses.testLink} onClick={viewTestHandler} title="View Test Details">
		   		{name} <img src={`images/infotran.gif`} alt="Infotran" />

			</span>
			<div className={CartClasses.buttonAreaLight}>
				{props.item.AAOE && <button className={CartClasses.buttonLightBlue} onClick={viewAAOEHandler} type="button">Update Answers</button>}
			</div>
			<AAOEModal 
				isOpen={showAAOEModal}
				onRequestClose = {closeAAOEModal}
				contentLabel = "Questions needed to be answered"
				style={{
				  content: {
					top: '200px',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translateX(-50%)',
					width: '60%',
					height: 'auto',
					padding: 0,
					background: 'transparent',
					border: 'none',
					boxShadow: 'none',
				  },
				  overlay: {
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				  }
				}}

				>
				<AAOE aaoes={aaoeData} aaoeA = {aaoeAns} onSubmit={handleAAOEData} onButtonClick={closeAAOEModal} />
			</AAOEModal>
			<div className={CartClasses.buttonAreaLight}>
			 	Price: ${DTCPrice.toFixed(2)}
					{!RequiredTest && <button className={CartClasses.buttonLightBlue} onClick={removeFromCartHandler}>Remove</button>}
			 </div>	
		</div>
		  
	  );
	};

export default CartItem;

